"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TYPE = exports.HTML_TYPE = exports.SIZE = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SIZE = {
  INHERIT: "inherit",
  SMALL: "small",
  MEDIUM: "medium",
  DEFAULT: "default",
  LARGE: "large"
};
exports.SIZE = SIZE;
var HTML_TYPE = {
  BUTTON: "button",
  SUBMIT: "submit",
  LINK: "link"
};
exports.HTML_TYPE = HTML_TYPE;
var TYPE = {
  EMPTY: "empty",
  DEFAULT: "default",
  PRIMARY: "primary",
  INFO: "info",
  LIGHT: "light",
  SECONDARY: "secondary",
  WARNING: "warning"
};
exports.TYPE = TYPE;

var Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getButtonContent", function () {
      return _this.props.loading ? /*#__PURE__*/_react.default.createElement("div", {
        className: "loading"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "loader-spin"
      })) : _this.props.children;
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      if (_this.props.onClick !== undefined) {
        _this.props.onClick(e);
      }
    });

    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          link = _this$props.link,
          type = _this$props.type,
          size = _this$props.size,
          outline = _this$props.outline,
          className = _this$props.className,
          fullWidth = _this$props.fullWidth,
          htmlType = _this$props.htmlType,
          loading = _this$props.loading,
          hasShadow = _this$props.hasShadow,
          rest = _objectWithoutProperties(_this$props, ["link", "type", "size", "outline", "className", "fullWidth", "htmlType", "loading", "hasShadow"]);

      var buttonClasses = (0, _classnames.default)("btn", "btn-".concat(type), "btn-".concat(size), className, {
        "full-width": fullWidth
      }, {
        "btn-outline": outline
      }, {
        "is-loading": loading
      }, {
        "btn-shadow": hasShadow
      });
      return htmlType === HTML_TYPE.LINK && link !== undefined ? /*#__PURE__*/_react.default.createElement("a", _extends({
        href: link,
        className: buttonClasses
      }, rest), this.getButtonContent()) : /*#__PURE__*/_react.default.createElement("button", _extends({
        onClick: this.handleClick,
        type: "button",
        className: buttonClasses,
        disabled: loading
      }, rest), this.getButtonContent());
    }
  }]);

  return Button;
}(_react.Component);

_defineProperty(Button, "SIZE", SIZE);

_defineProperty(Button, "HTML_TYPE", HTML_TYPE);

_defineProperty(Button, "TYPE", TYPE);

_defineProperty(Button, "defaultProps", {
  type: TYPE.SECONDARY,
  size: SIZE.MEDIUM,
  outline: false,
  fullWidth: false,
  htmlType: HTML_TYPE.BUTTON,
  loading: false,
  hasShadow: false
});

Button.propTypes = {
  type: _propTypes.default.oneOf([TYPE.EMPTY, TYPE.DEFAULT, TYPE.PRIMARY, TYPE.INFO, TYPE.LIGHT, TYPE.SECONDARY]),
  size: _propTypes.default.oneOf([SIZE.INHERIT, SIZE.SMALL, SIZE.DEFAULT, SIZE.MEDIUM, SIZE.LARGE]),
  outline: _propTypes.default.bool,
  fullWidth: _propTypes.default.bool,
  className: _propTypes.default.string,
  link: _propTypes.default.string,
  htmlType: _propTypes.default.oneOf([HTML_TYPE.BUTTON, HTML_TYPE.SUBMIT, HTML_TYPE.LINK]),
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  onClick: _propTypes.default.func,
  loading: _propTypes.default.bool,
  hasShadow: _propTypes.default.bool
};
var _default = Button;
exports.default = _default;